import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'softwareSmartTown',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '软件产品丨智能小镇管理系统'
              }
            },
            {
              path: '/software/bigData',
              name: 'softwareBigData',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '软件产品丨大数据管理系统'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/service/index'], resolve),
          meta: {
            title: '技术服务'
          },
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/newsinformation/newsDetails',
          name: 'newsDetails',
          component: resolve => require(['@/view/NewsDetails'], resolve),
          meta: {
            title: '新闻详情页'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: '相关服务'
          }
        },
        {
          path: '/service/development',
          name: 'serviceDevelopment',
          component: resolve => require(['@/view/service/development'], resolve),
          meta: {
            title: '软件产品 | 系统软件'
          }
        },
        {
          path: '/service/eda',
          name: 'serviceEda',
          component: resolve => require(['@/view/service/eda'], resolve),
          meta: {
            title: '软件产品 | EDA软件'
          }
        },
        {
          path: '/service/manufacture',
          name: 'serviceManufacture',
          component: resolve => require(['@/view/service/manufacture'], resolve),
          meta: {
            title: '软件产品 | 制造业软件'
          }
        },
        {
          path: '/service/offshore',
          name: 'serviceOffshore',
          component: resolve => require(['@/view/service/offshore'], resolve),
          meta: {
            title: '软件产品 | 海外软件'
          }
        },
      ]
    }
  ],
  mode: 'history',
  scrollBehavior: () => ({ y: 0 })
})



// WEBPACK FOOTER //
// ./src/router/index.js